import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import {
  DateBox,
  NumberBox,
  SelectBox,
  Template,
  TextBox,
} from "devextreme-react";
import { assetService } from "../../../apis/apiServices/Asset";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
} from "../../../helper/message";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { useGetCodeWiseAppModuleFeaturePermission } from "../../../helper/sessionHelper";
import { Loader } from "../../Shared/PageLoader";

const now = new Date();
const year = now.getFullYear();
const month = now.getMonth() + 1;

export default function ImportPRComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [state, setState] = useState({
    requestPurchaseId: 0,
    vendorId: 0,
    poNo: "",
    purchasePrice: 0,
    purchaseDate: "",
    rowData: null,
    ownershipTypeId: 0,
    ownershipTypeName: "",
    workOrderNo: "",
    workOrderDate: "",
    workOrderDuration: 0,
    workOrderPrice: 0,
    ewayBillNo: "",
    ewayBillExpiryDate: "",
    transportCharges: 0,
    grnNo: "",
    grnDate: "",
    sapErpFleetId: "",
    isUpdateRequestModalOpen: false,
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [errors, setErrors] = useState({
    ownerTypeValidation: "",
    vendorValidation: "",
    poNoValidation: "",
    purchasePriceValidation: "",
    purchaseDateValidation: "",
    workOrderNoValidation: "",
    workOrderPriceValidation: "",
    workOrderDateValidation: "",
    workOrderDurationValidation: "",
    ewayBillNoValidation: "",
    ewayBillExpiryDateValidation: "",
    //transportChargesValidation: "",
    grnNoValidation: "",
    grnDateValidation: "",
    sapErpFleetValidation: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [importPRList, setImportPRList] = useState([]);
  const [vendorDropdown, setVendorDropdown] = useState([]);
  const [ownerTypeDropdown, setOwnerTypeDropdown] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Import from SAP`;
  }, []);

  let materialRequestfeaturePermission = useGetCodeWiseAppModuleFeaturePermission("MATERIAL_MMR");
  // console.log("materialRequestfeaturePermission: " + materialRequestfeaturePermission);
  // console.log("materialRequestfeaturePermission: " + JSON.stringify(materialRequestfeaturePermission));

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getPurchaseRequestLst();
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getPurchaseRequestLst = async () => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      let body = {
        requestPurchaseId: 0,
        userId: user?.userId,
      };
      const response = await assetService.getAssetPurchaseRequestList(body);
      var data = response?.data?.filter(
        (e) =>
          e.statusId !== Number(AssetSubStatus.AssetPurchaseRequestApproved) &&
          e.isSendToSap
      );
      setImportPRList(data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getVendorDropdown = async () => {
    try {
      //const response = await vishwamApi.getVendorList(0);
      const response = await vishwamApi.GetVendorDropdown();
      //setVendorDropdown(response?.data?.filter((f) => f.isActive) ?? []);
      setVendorDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getOwnerTypeDropdown = async () => {
    try {
      const ownershipTypeList = [
        { id: 1, name: "Purchase Order" },
        { id: 2, name: "Service Order" },
      ];
      setOwnerTypeDropdown(ownershipTypeList ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnOpenUpdateRequestModal = (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isUpdateRequestModalOpen: true,
        requestPurchaseId: data?.requestPurchaseId ?? 0,
        vendorId: data?.vendorId ?? 0,
        poNo: data?.poNo ?? "",
        purchasePrice: data?.purchasePrise ?? 0,
        purchaseDate: data?.purchaseDate ?? "",
        rowData: data ?? null,
        movementTypeId: data?.movementTypeId ?? 0,
        ownershipTypeId: data?.ownershipTypeId ?? 0,
        ownershipTypeName: data?.ownershipType ?? "",
        workOrderNo: data?.leaseNo ?? "",
        workOrderDate: data?.leaseDate ?? "",
        workOrderDuration: data?.leaseDuration ?? 0,
        workOrderPrice: data?.servicePrice ?? 0,
        ewayBillNo: data?.ewayBillNo ?? "",
        ewayBillExpiryDate: data?.ewayExpiryDate?.toString() ?? "",
        transportCharges: data?.transportCharges ?? 0,
        grnNo: data?.grnNo ?? "",
        grnDate: data?.grnDate ?? "",
        sapErpFleetId: data?.sapFleetId ?? "",
      }));
      let err = { ...errors };
      err.poNoValidation = "";
      err.vendorValidation = "";
      err.purchasePriceValidation = "";
      err.purchaseDateValidation = "";
      err.workOrderNoValidation = "";
      err.workOrderPriceValidation = "";
      err.workOrderDateValidation = "";
      err.workOrderDurationValidation = "";
      err.ewayBillNoValidation = "";
      err.ewayBillExpiryDateValidation = "";
      //err.transportChargesValidation = "";
      err.ownerTypeValidation = "";
      err.grnNoValidation = "";
      err.grnDateValidation = "";
      err.sapErpFleetValidation = "";
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseUpdateRequestModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        requestPurchaseId: 0,
        vendorId: 0,
        poNo: "",
        purchasePrice: 0,
        purchaseDate: "",
        rowData: null,
        ownershipTypeId: 0,
        ownershipTypeName: "",
        workOrderNo: "",
        workOrderDate: "",
        workOrderDuration: 0,
        workOrderPrice: 0,
        ewayBillNo: "",
        ewayBillExpiryDate: "",
        transportCharges: 0,
        grnNo: "",
        grnDate: "",
        isUpdateRequestModalOpen: false,
        sapErpFleetId: "",
      }));
      setIsSubmitted(false);
      setOwnerTypeDropdown([]);
      setVendorDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.ownerTypeValidation = "";
      err.vendorValidation = "";
      err.poNoValidation = "";
      err.purchasePriceValidation = "";
      err.purchaseDateValidation = "";
      err.workOrderNoValidation = "";
      err.workOrderPriceValidation = "";
      err.workOrderDateValidation = "";
      err.workOrderDurationValidation = "";
      err.ewayBillNoValidation = "";
      err.ewayBillExpiryDateValidation = "";
      err.grnNoValidation = "";
      err.grnDateValidation = "";
      err.sapErpFleetValidation = "";
      //err.transportChargesValidation = "";
      if (
        state.rowData?.movementTypeId === 1 &&
        (state.rowData?.sapStatusId ===
          Number(AssetSubStatus.PODetailsPending) ||
          state.rowData?.sapStatusId ===
          Number(AssetSubStatus.ServiceDetailsPending))
      ) {
        if (state.ownershipTypeId === 0) {
          isValid = false;
          err.ownerTypeValidation = "Please select pr type.";
        }
        if (state.vendorId === 0) {
          isValid = false;
          err.vendorValidation = "Please select vendor.";
        }
        if (state.ownershipTypeId === 1) {
          if (!state.poNo) {
            isValid = false;
            err.poNoValidation = "Please enter po no.";
          }
          if (state.purchasePrice === 0 || !state.purchasePrice) {
            isValid = false;
            err.purchasePriceValidation = "Please enter purchase price.";
          }
          if (!state.purchaseDate) {
            isValid = false;
            err.purchaseDateValidation = "Please select purchase date.";
          }
        } else {
          if (!state.workOrderNo) {
            isValid = false;
            err.workOrderNoValidation = "Please enter work order no.";
          }
          // if (state.workOrderPrice === 0 || !state.workOrderPrice) {
          //   isValid = false;
          //   err.workOrderPriceValidation = "Please enter work order price.";
          // }
          if (!state.workOrderDate) {
            isValid = false;
            err.workOrderDateValidation = "Please select work order date.";
          }
          if (state.workOrderDuration === 0 || !state.workOrderDuration) {
            isValid = false;
            err.workOrderDurationValidation =
              "Please enter work order duration.";
          }
        }
      } else if (
        state.rowData?.movementTypeId === 1 &&
        state.rowData?.sapStatusId === Number(AssetSubStatus.GRNPending)
      ) {
        if (!state.grnNo) {
          isValid = false;
          err.grnNoValidation = "Please enter grn no.";
        }
        if (!state.grnDate) {
          isValid = false;
          err.grnDateValidation = "Please select grn date.";
        }
        if (!state.sapErpFleetId) {
          isValid = false;
          err.sapErpFleetValidation = "Please enter sap fleet id.";
        }
      } else if (
        state.rowData?.movementTypeId === 2 &&
        state.rowData?.sapStatusId === Number(AssetSubStatus.GRNPending)
      ) {
        if (!state.grnNo) {
          isValid = false;
          err.grnNoValidation = "Please enter grn no.";
        }
        if (!state.grnDate) {
          isValid = false;
          err.grnDateValidation = "Please select grn date.";
        }
      } else {
        if (!state.ewayBillNo) {
          isValid = false;
          err.ewayBillNoValidation = "Please enter eway bill no.";
        }
        if (!state.ewayBillExpiryDate) {
          isValid = false;
          err.ewayBillExpiryDateValidation =
            "Please select eway bill expiry date.";
        }
        // if (state.transportCharges === 0 || !state.transportCharges) {
        //   isValid = false;
        //   err.transportChargesValidation = "Please enter transport charges.";
        // }
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const GetWorkFlowForApprovers = async (
    formId,
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: formId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
      console.log("Movement Request Workflow body: " + JSON.stringify(body));
      console.log("Movement Request Workflow response: " + JSON.stringify(response));
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnSubmit = async (e, isSaveAsDraft) => {
    e.preventDefault();
    try {
      if (isValidData()) {
        let confirmationQuestion = "";
        if (state.rowData?.sapStatusId !== Number(AssetSubStatus.GRNPending)) {
          confirmationQuestion = `<span style='font-size:16px;'>Are You Sure Want To update Asset ${state.rowData?.movementTypeId === 1
              ? `${state?.rowData?.qwnershipTypeId === 1 ? `purchase` : `hire`
              } of pr type ${state?.rowData?.qwnershipTypeId === 1
                ? `purchase order details`
                : `service order details`
              }`
              : `Movement of type ${state?.rowData?.transportationName} details`
            }?</span>`;
        } else {
          confirmationQuestion = `<span style='font-size:16px;'>Are you sure you want to update the GRN details?</span>`;
        }

        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setIsSubmitted(true);
        let workflowCategoryId = 0;
        let Approvers = {};
        let workflowCategory = {};

        if (
          state.rowData?.movementTypeId === 1 &&
          state.rowData?.transportationTypeId === 1 &&
          !isSaveAsDraft
        ) {
          //console.log("materialRequestfeaturePermission data: " + JSON.stringify(materialRequestfeaturePermission));
          let categorybody = {
            formId: materialRequestfeaturePermission?.featureId,
            projectId: state.rowData?.toProjectId ?? 0,
            departmentId: state.rowData?.departmentId ?? 0,
          };
          const categoryresponse = await assetService.getWorkflowGroup(
            categorybody
          );
          console.log("Movement Request getWorkflowCategory body: " + JSON.stringify(categorybody));
          console.log("Movement Request getWorkflowCategory response: " + JSON.stringify(categoryresponse?.data));
          if (categoryresponse?.data.length >= 1) {
            workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
          }
          let workflowData = await GetWorkFlowForApprovers(
            materialRequestfeaturePermission?.featureId,
            workflowCategoryId,
            state.rowData?.toProjectId,
            state.rowData?.departmentId
          );
          const stagesWithApprovers = workflowData?.stages
            ?.filter(
              (stage) => stage?.approvers && stage?.approvers?.length > 0
            )
            ?.map((stage) => ({
              actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
              approvers: stage?.approvers,
            }));
          Approvers = workflowData?.stages
            ?.filter(
              (stage) => stage?.approvers && stage?.approvers?.length > 0
            )
            ?.flatMap((stage) =>
              stage?.approvers?.map((approver) => ({
                actionTypeId: stage?.actionTypeId,
                userId: approver?.userId,
                canEdit: approver?.canEdit,
                stageId: stage?.index,
              }))
            );
          workflowCategory.formId = materialRequestfeaturePermission?.featureId;
          workflowCategory.categoryId = workflowCategoryId;
          workflowCategory.projectId = state.rowData?.toProjectId;
          workflowCategory.departmentId = state.rowData?.departmentId;
          if (workflowData === null || workflowData === undefined) {
            setIsSubmitted(false);
            await showErrorMessage(
              `Workflow not set for this material movement request!!`
            );
            return;
          }
        }
        let updateBody = {
          prId: state.requestPurchaseId ?? 0,
          vendorId: state.vendorId ?? 0,
          ownershipTypeId: state.ownershipTypeId ?? 0,
          statusId: isSaveAsDraft
            ? AssetSubStatus.AssetPurchaseRequestDrafted
            : state.rowData?.sapStatusId !== Number(AssetSubStatus.GRNPending)
              ? AssetSubStatus.AssetPurchaseRequestDrafted
              : state.rowData?.sapStatusId === Number(AssetSubStatus.GRNPending)
                ? AssetSubStatus.AssetPurchaseRequestApproved
                : 0,
          modifiedBy: user?.userId ?? 0,
          poNo: state.ownershipTypeId === 1 ? state?.poNo : "",
          purchasePrice: state.ownershipTypeId === 1 ? state?.purchasePrice : 0,
          purchaseDate:
            state.ownershipTypeId === 1
              ? state?.purchaseDate
                ? moment(state?.purchaseDate)
                  ?.format(DefaultDateFormat.SqlDateFormat)
                  ?.toString()
                : ""
              : "",
          workOrderNo: state.ownershipTypeId === 2 ? state?.workOrderNo : "",
          workOrderDate:
            state.ownershipTypeId === 2
              ? state?.workOrderDate
                ? moment(state?.workOrderDate)
                  ?.format(DefaultDateFormat.SqlDateFormat)
                  ?.toString()
                : ""
              : "",
          workOrderDuration:
            state.ownershipTypeId === 2 ? state?.workOrderDuration : 0,
          workOrderPrice:
            state.ownershipTypeId === 2 ? state?.workOrderPrice : 0,
          movementTypeId: state.rowData?.movementTypeId ?? 0,
          ewayBillNo: state.ewayBillNo ?? "",
          ewayBillExpiryDate: state?.ewayBillExpiryDate
            ? moment(state?.ewayBillExpiryDate)
              ?.format(DefaultDateFormat.SqlDateFormat)
              ?.toString()
            : "",
          transportCharges: state.transportCharges ?? 0,
          importStatusId: isSaveAsDraft
            ? AssetSubStatus.ImportSapInDraftMode
            : state.rowData?.movementTypeId === 1 &&
              state.rowData?.sapStatusId !== Number(AssetSubStatus.GRNPending)
              ? Number(AssetSubStatus.ImportSapPending)
              : state.rowData?.movementTypeId === 1 &&
                state.rowData?.sapStatusId === Number(AssetSubStatus.GRNPending)
                ? Number(AssetSubStatus.ImportSapApproved)
                : state.rowData?.movementTypeId === 2 ||
                  state.rowData?.movementTypeId === 3
                  ? Number(AssetSubStatus.ImportSapApproved)
                  : 0,
          transportationTypeId: state.rowData?.transportationTypeId,
          grnNumber: state.grnNo || "",
          grnDate: state.grnDate
            ? moment(state.grnDate)
              ?.format(DefaultDateFormat.SqlDateFormat)
              ?.toString()
            : "",
          sapStatusId:
            state.rowData?.transportationTypeId === 2 &&
              !isSaveAsDraft &&
              (state.rowData?.sapStatusId ===
                Number(AssetSubStatus.PODetailsPending) ||
                state.rowData?.sapStatusId ===
                Number(AssetSubStatus.ServiceDetailsPending))
              ? Number(AssetSubStatus.GRNPending)
              : state.rowData?.transportationTypeId === 1 &&
                !isSaveAsDraft &&
                (state.rowData?.sapStatusId ===
                  Number(AssetSubStatus.PODetailsPending) ||
                  state.rowData?.sapStatusId ===
                  Number(AssetSubStatus.ServiceDetailsPending))
                ? Number(AssetSubStatus.SAPMovementPending)
                : state.rowData?.sapStatusId,
          sapFleetId: state.sapErpFleetId || "",
          assetRequestId: state.rowData?.assetRequestId || 0,
          materialFormId: materialRequestfeaturePermission?.featureId || 0,
          materialFormName: materialRequestfeaturePermission?.featureName || "",
          materialDepartmentId: state.rowData?.departmentId || 0,
          materialToProjectId: state.rowData?.toProjectId || 0,
          materialWorkflowId: workflowCategoryId || 0,
          applicationId: 3,
          workflowCategoryRequest: workflowCategory || [],
          isLoginUserRequester:
            Approvers?.[0]?.actionTypeId === 8 ? false : true,
          isGrnUpdated:
            state.rowData?.sapStatusId !== Number(AssetSubStatus.GRNPending)
              ? false
              : true,
        };

        //console.log(updateBody);
        if (
          !isSaveAsDraft &&
          state.rowData?.movementTypeId === 1 &&
          state.rowData?.sapStatusId === Number(AssetSubStatus.GRNPending)
        ) {
          const statusresponse = await assetService.getassetserial(year, month);
          const num = month < 10 ? "0" + month : month;
          let assetSerialNo =
            "VSE" + "/" + year + "/" + num + "/" + statusresponse;
          let assetBody = {
            assetId: 0,
            name: state.rowData?.assetDescriptions || "",
            assetSerial: assetSerialNo || "",
            categoryId: state.rowData?.categoryId || 0,
            subCategoryId: state.rowData?.subCategoryId || 0,
            uomId: state.rowData?.uomId || 0,
            statusId: AssetSubStatus.New,
            hsnNumber: state.rowData?.hsnNumber || "",
            vseFleetid: state.rowData?.vseFleetId || "",
            erpFleetid: state.sapErpFleetId || "",
            poNo: state.poNo || "",
            assignDepartmentId: state.rowData?.assignDeptId || 0,
            assignedId: state.rowData?.assignedUserId || 0,
            custodian1DepartmentId: state.rowData?.custodian1DeptId || 0,
            custodianId1: state.rowData?.custodianUserId1 || 0,
            custodian2DepartmentId: state.rowData?.custodian2DeptId || 0,
            custodianId2: state.rowData?.custodianUserId2 || 0,
            model: state.rowData?.model || "",
            make: state.rowData?.make || "",
            material: state.rowData?.material || "",
            weight: state.rowData?.weight || 0,
            size: state.rowData?.size || "",
            invoiceAmount: state.purchasePrice || 0,
            invoiceDate: state?.purchaseDate
              ? moment(state?.purchaseDate)
                ?.format(DefaultDateFormat.SqlDateFormat)
                ?.toString()
              : "",
            projectId: state.rowData?.toProjectId || 0,
            rfid: state.rowData?.rfid || "",
            skuCode: state.rowData?.skucode || "",
            assetModelSerialNo: state.rowData?.assetModelSerialNo || "",
            mfgDate: state.rowData?.mfgDate
              ? moment(state.rowData?.mfgDate)
                ?.format(DefaultDateFormat.SqlDateFormat)
                ?.toString()
              : "",
            isActive: true,
            modifiedBy: user?.userId,
            assetDesc: state.rowData?.assetDesc || "",
            assetLocationId: state.rowData?.assetLocationId || 0,
            makeYear: state.rowData?.makeYear || "",
            ownerTypeId: state.rowData?.ownershipTypeId || 0,
            leaseNo: state.rowData?.leaseNo || "",
            leaseDate: state.rowData?.leaseDate
              ? moment(state.rowData?.leaseDate)
                ?.format(DefaultDateFormat.SqlDateFormat)
                ?.toString()
              : "",
            assetReachedAtSite: state.rowData?.assetReachedAtSite
              ? moment(state.rowData?.assetReachedAtSite)
                ?.format(DefaultDateFormat.SqlDateFormat)
                ?.toString()
              : "",
            leaseDuration: state.rowData?.leaseDuration || 0,
            assetLabelNo: state.rowData?.assetLabelNo || "",
            vendorId: state.rowData?.vendorId || 0,
            groupId: state.rowData?.groupId || 0,
            assetTranSpecification: [],
            assetPurchaseId: state.requestPurchaseId,
            assetPurchaseSubId: 0,
            assetRequestId: state.rowData?.assetRequestId || 0,
            assetRequestSubId: state.rowData?.assetRequestSubId || 0,
          };
          await assetService.addAsset(assetBody);
        }
        const response = await assetService.updateAssetPR(updateBody);
        isConfirmed = await showResponseMessage(response);
        setIsSubmitted(false);
        if (response?.isSuccess) {
          handleOnCloseUpdateRequestModal();
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: true,
          }));
          await getPurchaseRequestLst();
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: false,
          }));
        }
      }
    } catch (error) {
      setIsSubmitted(false);
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              dataSource={importPRList}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift({
                  location: "before",
                  template: "toolbarRefreshTemplate",
                });
              }}
            >
              <Column
                dataField="requestPurchaseId"
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                width={165}
                cellRender={(cellData) => {
                  const rowData = cellData?.data;
                  const idPrefix = `icon-${rowData?.requestPurchaseId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (rowData?.movementTypeId === 1) {
                                    navigate(
                                      rowData?.quotationTypeId === 1
                                        ? "/asset-purchase-preview"
                                        : "/asset-hire-preview",
                                      {
                                        state: {
                                          requestQuotationId:
                                            rowData?.assetQuotationId,
                                          quotationIndentNo:
                                            rowData?.purchaseIndentNo,
                                          quotationTypeId:
                                            rowData?.quotationTypeId,
                                          sourceUrl:
                                            rowData?.quotationTypeId === 1
                                              ? "ImportSAPRequestAssetPurchase"
                                              : rowData?.quotationTypeId === 2
                                                ? "ImportSAPRequestAssetHire"
                                                : "",
                                          isReport: false,
                                        },
                                      }
                                    );
                                  } else if (rowData?.movementTypeId === 2) {
                                    navigate("/asset-movement-preview", {
                                      state: {
                                        requestMovementId:
                                          rowData?.requestPurchaseId,
                                        movementIndentNo:
                                          rowData?.purchaseIndentNo,
                                        sourceUrl: "ImportSAPAssetMovement",
                                        isReport: false,
                                      },
                                    });
                                  } else if (rowData?.movementTypeId === 3) {
                                    navigate(
                                      "/material-movement-order-preview",
                                      {
                                        state: {
                                          requestMovementId:
                                            rowData?.requestPurchaseId,
                                          materialMovementOrderIndentNo:
                                            rowData?.purchaseIndentNo,
                                          sourceUrl:
                                            "ImportSAPMaterialMovementOrder",
                                          isReport: false,
                                        },
                                      }
                                    );
                                  }
                                }}
                              />
                            </span>
                          </>
                        )}
                        &nbsp;                          
                            {/* //rowData.departmentId === user?.userDepartmentId && (
                            // (rowData.actionAllowed || rowData.aorActionAllowed) && (                            
                            //   <button 
                            //     style={{ cursor: "pointer" }}
                            //     type="button"
                            //     title="Action"
                            //     className="btn btn-primary btn-sm-1"
                            //     onClick={(e) => {
                            //       handleOnOpenUpdateRequestModal(e, rowData);
                            //     }}
                            //     hidden={
                            //       rowData?.sapStatusId ===
                            //       Number(AssetSubStatus.SAPMovementPending) &&
                            //       (rowData?.transportationTypeId === 1 ||
                            //         rowData?.isMovementApproved ||
                            //         rowData?.transportationId === 1 ||
                            //         rowData?.transportationId === 2)
                            //     }
                            //   >
                            //     <Icon
                            //       className="iconify-size mr-1"
                            //       icon="mdi:call-to-action"
                            //       width="14"
                            //       height="14"
                            //     />
                            //     &nbsp;
                            //     {`${rowData?.movementTypeId === 1 &&
                            //         rowData?.sapStatusId !==
                            //         Number(AssetSubStatus.GRNPending)
                            //         ? `${rowData?.ownershipType}`
                            //         : (rowData?.movementTypeId === 1 ||
                            //           rowData?.movementTypeId === 2 ||
                            //           rowData?.movementTypeId === 3) &&
                            //           rowData?.sapStatusId === Number(AssetSubStatus.GRNPending) && rowData.aorActionAllowed
                            //           ? `GRN Details`
                            //           : `${rowData?.transportationId === 1
                            //             ? `EWAY BILL`
                            //             : `SERVICE ORDER`
                            //           }`
                            //       }`}
                            //   </button>
                            // ) */}
                        <span>
                          {rowData?.actionAllowed &&
                            rowData?.sapStatusId !==
                            Number(AssetSubStatus.GRNPending) && (
                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Action"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={(e) => {
                                    handleOnOpenUpdateRequestModal(e, rowData);
                                  }}
                                  hidden={
                                    rowData?.sapStatusId ===
                                    Number(
                                      AssetSubStatus.SAPMovementPending
                                    ) &&
                                    (rowData?.transportationTypeId === 1 ||
                                      rowData?.isMovementApproved ||
                                      rowData?.transportationId === 1 ||
                                      rowData?.transportationId === 2)
                                  }
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="mdi:call-to-action"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;
                                  {`${rowData?.movementTypeId === 1
                                      ? `${rowData?.ownershipType}`
                                      : `${rowData?.transportationId === 1
                                        ? `EWAY BILL`
                                        : `SERVICE ORDER`
                                      }`
                                    }`}
                                </button>
                              </>
                            )}
                        </span>
                        <span>
                          {rowData?.aorActionAllowed &&
                            rowData?.sapStatusId ===
                            Number(AssetSubStatus.GRNPending) && (
                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Action"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={(e) => {
                                    handleOnOpenUpdateRequestModal(e, rowData);
                                  }}
                                // hidden={
                                //   rowData?.sapStatusId ===
                                //     Number(
                                //       AssetSubStatus.SAPMovementPending
                                //     ) &&
                                //   (rowData?.transportationTypeId === 1 ||
                                //     rowData?.isMovementApproved ||
                                //     rowData?.transportationId === 1 ||
                                //     rowData?.transportationId === 2)
                                // }
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="mdi:call-to-action"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;
                                  {rowData?.movementTypeId !== 3 && (
                                    <span>GRN Details</span>
                                  )}
                                </button>
                              </>
                            )}
                        </span>
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="transportationType"
                caption="Transportation Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="movementTypeName"
                caption="Request Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetRequestSubNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="purchaseIndentNo"
                caption="Order No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="purchaseRequestNo"
                caption="Purchase No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                dataField="importPrStatus"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="assetStatusName"
                caption="Status"
                visible={false}
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestDrafted
                  )
                    color = "#494545ff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestPending
                  )
                    color = "#494545ff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetPurchaseRequestSentforApproval
                  )
                    color = "#FF9800";

                  return (
                    <div>
                      <span style={{ color }}>{e.data?.assetStatusName}</span>
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.fromName}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="sapStatusName"
                caption="SAP Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetDescriptions"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="ownershipType"
                caption="PR Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="requestedDate"
                caption="Request Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format="dd-MMM-yyyy"
              />
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromName || ""} ${data?.fromDepartment || ""
                    }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.fromName) {
                    return (
                      <>
                        <span>{data?.data?.fromName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.fromDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.toName || ""} ${data?.toDepartment || ""}`;
                }}
                cellRender={(data) => {
                  if (data?.data?.toName) {
                    return (
                      <>
                        <span>{data?.data?.toName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toProjectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
              />

              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getPurchaseRequestLst();
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={10} />
              <Pager
                allowedPageSizes={[10, 15, 20, 50, 100]}
                showPageSizeSelector={true}
                showInfo={true}
                visible={true}
                showNavigationButtons={true}
              />
              <Export enabled={true} fileName="Import PR" />
            </DataGrid>
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={state.isUpdateRequestModalOpen}
        className="react-modal custom-modal-medium"
        onAfterOpen={async () => {
          await getOwnerTypeDropdown();
          await getVendorDropdown();
        }}
        shouldCloseOnOverlayClick={false}
        contentLabel="Update Asset Purchase / Movement Details Modal"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`${state.rowData?.movementTypeId === 1
                ? `Update Asset ${state.rowData?.ownershipTypeId === 1 ? `Purchase` : `Hire`
                }`
                : state.rowData?.movementTypeId === 2
                  ? `Update Asset Movement`
                  : state.rowData?.movementTypeId === 3
                    ? `Update Material Movement Order`
                    : ``
              }`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseUpdateRequestModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          {state.rowData?.movementTypeId === 1 ? (
            <>
              {(state.rowData?.sapStatusId ===
                Number(AssetSubStatus.PODetailsPending) ||
                state.rowData?.sapStatusId ===
                Number(AssetSubStatus.ServiceDetailsPending)) && (
                  <>
                    <div className="row">
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          <label>
                            PR Type&nbsp;<span className="text-danger">*</span>
                          </label>
                          <SelectBox
                            dataSource={ownerTypeDropdown}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select owner type"
                            name="ownerTypeDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.ownershipTypeId}
                            defaultValue={state.ownershipTypeId}
                            showClearButton={true}
                            searchEnabled={true}
                            readOnly={true}
                            disabled={false}
                            onSelectionChanged={(e) => {
                              let err = { ...errors };
                              err.ownerTypeValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                ownershipTypeId: e?.selectedItem?.id ?? 0,
                                ownershipTypeName: e?.selectedItem?.name ?? "",
                              }));
                            }}
                          />
                          {errors.ownerTypeValidation && (
                            <div className="text-danger">
                              {errors.ownerTypeValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          <label>
                            Vendor&nbsp;<span className="text-danger">*</span>
                          </label>
                          <SelectBox
                            dataSource={vendorDropdown}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select vendor"
                            name="vendorDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.vendorId}
                            defaultValue={state.vendorId}
                            showClearButton={true}
                            searchEnabled={true}
                            readOnly={false}
                            disabled={true}
                            onSelectionChanged={(e) => {
                              let err = { ...errors };
                              err.vendorValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                vendorId: e?.selectedItem?.id ?? 0,
                              }));
                            }}
                          />
                          {errors.vendorValidation && (
                            <div className="text-danger">
                              {errors.vendorValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      {state.ownershipTypeId === 1 && (
                        <>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                PO No.&nbsp;<span className="text-danger">*</span>
                              </label>
                              <TextBox
                                name="poNo"
                                className="form-control form-control-sm"
                                height={37}
                                placeholder="Enter po no"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                  let err = { ...errors };
                                  err.poNoValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    poNo: e.value ?? "",
                                  }));
                                }}
                                value={state.poNo}
                              />
                              {errors.poNoValidation && (
                                <div className="text-danger">
                                  {errors.poNoValidation}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Purchase Price&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <NumberBox
                                name="purchasePrice"
                                className="form-control form-control-sm"
                                height={37}
                                placeholder="Enter purchase price"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                  let err = { ...errors };
                                  err.purchasePriceValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    purchasePrice: e.value ?? "",
                                  }));
                                }}
                                value={Number(state.purchasePrice ?? 0) || ""}
                              />
                              {errors.purchasePriceValidation && (
                                <div className="text-danger">
                                  {errors.purchasePriceValidation}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Purchase Date&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <DateBox
                                type="date"
                                className="form-control"
                                name="purchaseDate"
                                placeholder={DefaultDateFormat.DateFormat1}
                                displayFormat={DefaultDateFormat.DateFormat1}
                                showAnalogClock={false}
                                useMaskBehavior={false}
                                defaultValue={state.purchaseDate}
                                value={state.purchaseDate}
                                disabled={false}
                                acceptCustomValue={true}
                                onValueChanged={(date) => {
                                  let err = { ...errors };
                                  err.purchaseDateValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    purchaseDate: date.value,
                                  }));
                                }}
                              />
                              {errors.purchaseDateValidation && (
                                <div className="text-danger">
                                  {errors.purchaseDateValidation}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {state.ownershipTypeId === 2 && (
                        <>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Work Order No.&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <TextBox
                                name="workOrderNo"
                                className="form-control form-control-sm"
                                height={37}
                                placeholder="Enter work order no"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                  let err = { ...errors };
                                  err.workOrderNoValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    workOrderNo: e.value ?? "",
                                  }));
                                }}
                                value={state.workOrderNo}
                              />
                              {errors.workOrderNoValidation && (
                                <div className="text-danger">
                                  {errors.workOrderNoValidation}
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            className="col-12 col-lg-12"
                            style={{ display: "none" }}
                          >
                            <div className="form-group mb-2">
                              <label>
                                Work Order Price&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <NumberBox
                                name="workOrderPrice"
                                className="form-control form-control-sm"
                                height={37}
                                placeholder="Enter work order price"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                  let err = { ...errors };
                                  err.workOrderPriceValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    workOrderPrice: e.value ?? "",
                                  }));
                                }}
                                value={Number(state.workOrderPrice ?? 0) || ""}
                              />
                              {errors.workOrderPriceValidation && (
                                <div className="text-danger">
                                  {errors.workOrderPriceValidation}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Work Order Date&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <DateBox
                                type="date"
                                className="form-control"
                                name="workOrderDate"
                                placeholder={DefaultDateFormat.DateFormat1}
                                displayFormat={DefaultDateFormat.DateFormat1}
                                showAnalogClock={false}
                                useMaskBehavior={false}
                                defaultValue={state.workOrderDate}
                                value={state.workOrderDate}
                                disabled={false}
                                acceptCustomValue={true}
                                onValueChanged={(date) => {
                                  let err = { ...errors };
                                  err.workOrderDateValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    workOrderDate: date.value,
                                  }));
                                }}
                              />
                              {errors.workOrderDateValidation && (
                                <div className="text-danger">
                                  {errors.workOrderDateValidation}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Service Type&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <TextBox
                                className="form-control form-control-sm"
                                height={37}
                                showClearButton={true}
                                readOnly={true}
                                value={state.rowData?.servieTypeName}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Requested Hiring Quantity&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <NumberBox
                                className="form-control form-control-sm"
                                height={37}
                                showClearButton={true}
                                readOnly={true}
                                value={state.rowData?.hiringQunatity}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Work Order Duration&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <NumberBox
                                name="workOrderDuration"
                                className="form-control form-control-sm"
                                height={37}
                                placeholder="Enter work order duration"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                  let err = { ...errors };
                                  err.workOrderDurationValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    workOrderDuration: e.value ?? "",
                                  }));
                                }}
                                value={Number(state.workOrderDuration ?? 0) || ""}
                              />
                              {errors.workOrderDurationValidation && (
                                <div className="text-danger">
                                  {errors.workOrderDurationValidation}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              {state.rowData?.sapStatusId ===
                Number(AssetSubStatus.GRNPending) && (
                  <>
                    <div className="row">
                      <div className="col-12 col-lg-4">
                        <div className="form-group mb-2">
                          <label>
                            GRN No.&nbsp;<span className="text-danger">*</span>
                          </label>
                          <TextBox
                            name="grnNo"
                            className="form-control form-control-sm"
                            height={37}
                            placeholder="Enter grn no."
                            showClearButton={true}
                            valueChangeEvent="keyup"
                            onValueChanged={(e) => {
                              let err = { ...errors };
                              err.grnNoValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                grnNo: e.value ?? "",
                              }));
                            }}
                            value={state.grnNo}
                          />
                          {errors.grnNoValidation && (
                            <div className="text-danger">
                              {errors.grnNoValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-4">
                        <div className="form-group mb-2">
                          <label>
                            GRN Date&nbsp;<span className="text-danger">*</span>
                          </label>
                          <DateBox
                            type="date"
                            className="form-control"
                            name="grnDate"
                            placeholder={DefaultDateFormat.DateFormat1}
                            displayFormat={DefaultDateFormat.DateFormat1}
                            showAnalogClock={false}
                            useMaskBehavior={false}
                            defaultValue={state.grnDate}
                            value={state.grnDate}
                            //min={moment(new Date(), "MM/DD/YYYY").add(0, "day")}
                            disabled={false}
                            acceptCustomValue={true}
                            onValueChanged={(date) => {
                              let err = { ...errors };
                              err.grnDateValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                grnDate: date.value,
                              }));
                            }}
                          />
                          {errors.grnDateValidation && (
                            <div className="text-danger">
                              {errors.grnDateValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-4">
                        <div className="form-group mb-2">
                          <label>
                            SAP Fleet Id&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <TextBox
                            name="sapErpFleetId"
                            className="form-control form-control-sm"
                            height={37}
                            placeholder="Enter sap fleet id"
                            showClearButton={true}
                            valueChangeEvent="keyup"
                            onValueChanged={(e) => {
                              let err = { ...errors };
                              err.sapErpFleetValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                sapErpFleetId: e.value ?? "",
                              }));
                            }}
                            value={state.sapErpFleetId}
                          />
                          {errors.sapErpFleetValidation && (
                            <div className="text-danger">
                              {errors.sapErpFleetValidation}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
            </>
          ) : (
            // : (state.rowData?.movementTypeId === 2) ? (
            //   <>
            //     {state.rowData?.sapStatusId ===
            //       Number(AssetSubStatus.GRNPending) && (
            //       <>
            //         <div className="row">
            //           <div className="col-12 col-lg-6">
            //             <div className="form-group mb-2">
            //               <label>
            //                 GRN No.&nbsp;<span className="text-danger">*</span>
            //               </label>
            //               <TextBox
            //                 name="grnNo"
            //                 className="form-control form-control-sm"
            //                 height={37}
            //                 placeholder="Enter grn no."
            //                 showClearButton={true}
            //                 valueChangeEvent="keyup"
            //                 onValueChanged={(e) => {
            //                   let err = { ...errors };
            //                   err.grnNoValidation = "";
            //                   setErrors(err);
            //                   setState((prev) => ({
            //                     ...prev,
            //                     grnNo: e.value ?? "",
            //                   }));
            //                 }}
            //                 value={state.grnNo}
            //               />
            //               {errors.grnNoValidation && (
            //                 <div className="text-danger">
            //                   {errors.grnNoValidation}
            //                 </div>
            //               )}
            //             </div>
            //           </div>
            //           <div className="col-12 col-lg-6">
            //             <div className="form-group mb-2">
            //               <label>
            //                 GRN Date&nbsp;<span className="text-danger">*</span>
            //               </label>
            //               <DateBox
            //                 type="date"
            //                 className="form-control"
            //                 name="grnDate"
            //                 placeholder={DefaultDateFormat.DateFormat1}
            //                 displayFormat={DefaultDateFormat.DateFormat1}
            //                 showAnalogClock={false}
            //                 useMaskBehavior={false}
            //                 defaultValue={state.grnDate}
            //                 value={state.grnDate}
            //                 //min={moment(new Date(), "MM/DD/YYYY").add(0, "day")}
            //                 disabled={false}
            //                 acceptCustomValue={true}
            //                 onValueChanged={(date) => {
            //                   let err = { ...errors };
            //                   err.grnDateValidation = "";
            //                   setErrors(err);
            //                   setState((prev) => ({
            //                     ...prev,
            //                     grnDate: date.value,
            //                   }));
            //                 }}
            //               />
            //               {errors.grnDateValidation && (
            //                 <div className="text-danger">
            //                   {errors.grnDateValidation}
            //                 </div>
            //               )}
            //             </div>
            //           </div>
            //         </div>
            //       </>
            //     )}
            //   </>
            // )
            <>
              <div className="row">
                {state.rowData?.movementTypeId === 2 &&
                  state.rowData?.sapStatusId ===
                  Number(AssetSubStatus.GRNPending) && (
                    <>
                      {state.rowData?.sapStatusId ===
                        Number(AssetSubStatus.GRNPending) && (
                          <>
                            <div className="row">
                              <div className="col-12 col-lg-4">
                                <div className="form-group mb-2">
                                  <label>
                                    GRN No.&nbsp;
                                    <span className="text-danger">*</span>
                                  </label>
                                  <TextBox
                                    name="grnNo"
                                    className="form-control form-control-sm"
                                    height={37}
                                    placeholder="Enter grn no."
                                    showClearButton={true}
                                    valueChangeEvent="keyup"
                                    onValueChanged={(e) => {
                                      let err = { ...errors };
                                      err.grnNoValidation = "";
                                      setErrors(err);
                                      setState((prev) => ({
                                        ...prev,
                                        grnNo: e.value ?? "",
                                      }));
                                    }}
                                    value={state.grnNo}
                                  />
                                  {errors.grnNoValidation && (
                                    <div className="text-danger">
                                      {errors.grnNoValidation}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-12 col-lg-4">
                                <div className="form-group mb-2">
                                  <label>
                                    GRN Date&nbsp;
                                    <span className="text-danger">*</span>
                                  </label>
                                  <DateBox
                                    type="date"
                                    className="form-control"
                                    name="grnDate"
                                    placeholder={DefaultDateFormat.DateFormat1}
                                    displayFormat={DefaultDateFormat.DateFormat1}
                                    showAnalogClock={false}
                                    useMaskBehavior={false}
                                    defaultValue={state.grnDate}
                                    value={state.grnDate}
                                    //min={moment(new Date(), "MM/DD/YYYY").add(0, "day")}
                                    disabled={false}
                                    acceptCustomValue={true}
                                    onValueChanged={(date) => {
                                      let err = { ...errors };
                                      err.grnDateValidation = "";
                                      setErrors(err);
                                      setState((prev) => ({
                                        ...prev,
                                        grnDate: date.value,
                                      }));
                                    }}
                                  />
                                  {errors.grnDateValidation && (
                                    <div className="text-danger">
                                      {errors.grnDateValidation}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* <div className="col-12 col-lg-4">
                              <div className="form-group mb-2">
                                <label>
                                  SAP Fleet Id&nbsp;
                                  <span className="text-danger">*</span>
                                </label>
                                <TextBox
                                  name="sapErpFleetId"
                                  className="form-control form-control-sm"
                                  height={37}
                                  placeholder="Enter sap fleet id"
                                  showClearButton={true}
                                  valueChangeEvent="keyup"
                                  onValueChanged={(e) => {
                                    let err = { ...errors };
                                    err.sapErpFleetValidation = "";
                                    setErrors(err);
                                    setState((prev) => ({
                                      ...prev,
                                      sapErpFleetId: e.value ?? "",
                                    }));
                                  }}
                                  value={state.sapErpFleetId}
                                />
                                {errors.sapErpFleetValidation && (
                                  <div className="text-danger">
                                    {errors.sapErpFleetValidation}
                                  </div>
                                )}
                              </div>
                            </div> */}
                            </div>
                          </>
                        )}
                    </>
                  )}

                {state.rowData?.movementTypeId === 3 &&
                  state.rowData?.sapStatusId ===
                  Number(AssetSubStatus.GRNPending) && (
                    <>
                      {state.rowData?.sapStatusId ===
                        Number(AssetSubStatus.GRNPending) && (
                          <>
                            <div className="row">
                              <div className="col-12 col-lg-4">
                                <div className="form-group mb-2">
                                  <label>
                                    GRN No.&nbsp;
                                    <span className="text-danger">*</span>
                                  </label>
                                  <TextBox
                                    name="grnNo"
                                    className="form-control form-control-sm"
                                    height={37}
                                    placeholder="Enter grn no."
                                    showClearButton={true}
                                    valueChangeEvent="keyup"
                                    onValueChanged={(e) => {
                                      let err = { ...errors };
                                      err.grnNoValidation = "";
                                      setErrors(err);
                                      setState((prev) => ({
                                        ...prev,
                                        grnNo: e.value ?? "",
                                      }));
                                    }}
                                    value={state.grnNo}
                                  />
                                  {errors.grnNoValidation && (
                                    <div className="text-danger">
                                      {errors.grnNoValidation}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-12 col-lg-4">
                                <div className="form-group mb-2">
                                  <label>
                                    GRN Date&nbsp;
                                    <span className="text-danger">*</span>
                                  </label>
                                  <DateBox
                                    type="date"
                                    className="form-control"
                                    name="grnDate"
                                    placeholder={DefaultDateFormat.DateFormat1}
                                    displayFormat={DefaultDateFormat.DateFormat1}
                                    showAnalogClock={false}
                                    useMaskBehavior={false}
                                    defaultValue={state.grnDate}
                                    value={state.grnDate}
                                    //min={moment(new Date(), "MM/DD/YYYY").add(0, "day")}
                                    disabled={false}
                                    acceptCustomValue={true}
                                    onValueChanged={(date) => {
                                      let err = { ...errors };
                                      err.grnDateValidation = "";
                                      setErrors(err);
                                      setState((prev) => ({
                                        ...prev,
                                        grnDate: date.value,
                                      }));
                                    }}
                                  />
                                  {errors.grnDateValidation && (
                                    <div className="text-danger">
                                      {errors.grnDateValidation}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* <div className="col-12 col-lg-4">
                              <div className="form-group mb-2">
                                <label>
                                  SAP Fleet Id&nbsp;
                                  <span className="text-danger">*</span>
                                </label>
                                <TextBox
                                  name="sapErpFleetId"
                                  className="form-control form-control-sm"
                                  height={37}
                                  placeholder="Enter sap fleet id"
                                  showClearButton={true}
                                  valueChangeEvent="keyup"
                                  onValueChanged={(e) => {
                                    let err = { ...errors };
                                    err.sapErpFleetValidation = "";
                                    setErrors(err);
                                    setState((prev) => ({
                                      ...prev,
                                      sapErpFleetId: e.value ?? "",
                                    }));
                                  }}
                                  value={state.sapErpFleetId}
                                />
                                {errors.sapErpFleetValidation && (
                                  <div className="text-danger">
                                    {errors.sapErpFleetValidation}
                                  </div>
                                )}
                              </div>
                            </div> */}
                            </div>
                          </>
                        )}
                    </>
                  )}

                {state.rowData?.movementTypeId >= 2 &&
                  state.rowData?.sapStatusId !==
                  Number(AssetSubStatus.GRNPending) && (
                    <>
                      {state.rowData?.movementTypeId === 2 && (
                        <>
                          {" "}
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Asset Description&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <TextBox
                                name="assetDescriptions"
                                className="form-control form-control-sm"
                                height={37}
                                readOnly={true}
                                showClearButton={true}
                                value={state.rowData?.assetDescriptions}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Asset Serial No.&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <TextBox
                                name="allocatedAssetSerialNo"
                                className="form-control form-control-sm"
                                height={37}
                                readOnly={true}
                                showClearButton={true}
                                value={state.rowData?.allocatedAssetSerialNo}
                              />
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          <label>
                            Vehicle No.&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <TextBox
                            name="transportVehicleNo"
                            className="form-control form-control-sm"
                            height={37}
                            readOnly={true}
                            showClearButton={true}
                            value={state.rowData?.transportVehicleNo}
                          />
                        </div>
                      </div>
                      {state.rowData?.transportationId === 2 && (
                        <>
                          <div className="col-12 col-lg-12">
                            <div className="form-group mb-2">
                              <label>
                                Vendor&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <TextBox
                                name="transportVendorName"
                                className="form-control form-control-sm"
                                height={37}
                                readOnly={true}
                                showClearButton={true}
                                value={state.rowData?.transportVendorName}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          <label>
                            {state.rowData?.transportationId === 1
                              ? "Eway Bill No"
                              : "Work Order No"}
                            &nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <TextBox
                            name="ewayBillNo"
                            className="form-control form-control-sm"
                            height={37}
                            placeholder={
                              state.rowData?.transportationId === 1
                                ? "Enter eway bill no"
                                : "Enter work order no"
                            }
                            showClearButton={true}
                            valueChangeEvent="keyup"
                            onValueChanged={(e) => {
                              let err = { ...errors };
                              err.ewayBillNoValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                ewayBillNo: e.value ?? "",
                              }));
                            }}
                            value={state.ewayBillNo}
                          />
                          {errors.ewayBillNoValidation && (
                            <div className="text-danger">
                              {errors.ewayBillNoValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          <label>
                            {state.rowData?.transportationId === 1
                              ? "Eway Bill Expiry Date"
                              : "Work Order Date"}
                            &nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <DateBox
                            type="date"
                            className="form-control"
                            name="ewayBillExpiryDate"
                            placeholder={DefaultDateFormat.DateFormat1}
                            displayFormat={DefaultDateFormat.DateFormat1}
                            showAnalogClock={false}
                            useMaskBehavior={false}
                            defaultValue={state.ewayBillExpiryDate}
                            value={state.ewayBillExpiryDate}
                            min={moment(new Date(), "MM/DD/YYYY").add(0, "day")}
                            disabled={false}
                            acceptCustomValue={true}
                            onValueChanged={(date) => {
                              let err = { ...errors };
                              err.ewayBillExpiryDateValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                ewayBillExpiryDate: date.value,
                              }));
                            }}
                          />
                          {errors.ewayBillExpiryDateValidation && (
                            <div className="text-danger">
                              {errors.ewayBillExpiryDateValidation}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                {/* <div className="col-12 col-lg-12">
                  <div className="form-group mb-2">
                    <label>
                      Transport Charges&nbsp;
                      <span className="text-danger">*</span>
                    </label>
                    <NumberBox
                      name="transportCharges"
                      className="form-control form-control-sm"
                      height={37}
                      placeholder="Enter transport charges"
                      showClearButton={true}
                      valueChangeEvent="keyup"
                      onValueChanged={(e) => {
                        let err = { ...errors };
                        err.workOrderPriceValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          transportCharges: e.value ?? "",
                        }));
                      }}
                      value={Number(state.transportCharges ?? 0) || ""}
                    />
                    {errors.transportChargesValidation && (
                      <div className="text-danger">
                        {errors.transportChargesValidation}
                      </div>
                    )}
                  </div>
                </div> */}
              </div>
            </>
          )}
        </div>
        <div className="modal-footer">
          {state.rowData?.importPrStatusId ===
            Number(AssetSubStatus.ImportSapPending) && (
              <>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  title="Save As Draft"
                  onClick={async (e) => {
                    await handleOnSubmit(e, true);
                  }}
                  disabled={isSubmitted}
                >
                  <span title="Save">
                    <i
                      className={`fas fa-${isSubmitted ? `spinner fa-spin` : `file-signature`
                        }`}
                    />
                    &nbsp;&nbsp;Save
                  </span>
                </button>
                &nbsp;&nbsp;
              </>
            )}
          {state.rowData?.importPrStatusId ===
            Number(AssetSubStatus.ImportSapInDraftMode) && (
              <>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  title="Save As Draft"
                  onClick={async (e) => {
                    await handleOnSubmit(e, true);
                  }}
                  disabled={isSubmitted}
                >
                  <span title="Save">
                    <i
                      className={`fas fa-${isSubmitted ? `spinner fa-spin` : `file-signature`
                        }`}
                    />
                    &nbsp;&nbsp;Save
                  </span>
                </button>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  title="Save & Approve"
                  onClick={async (e) => {
                    await handleOnSubmit(e, false);
                  }}
                  disabled={isSubmitted}
                >
                  <span title="Save & Approve">
                    <i
                      className={`fas fa-${isSubmitted ? `spinner fa-spin` : `check`
                        }`}
                    />
                    &nbsp;&nbsp;Save & Approve
                  </span>
                </button>
                &nbsp;&nbsp;
              </>
            )}
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseUpdateRequestModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
